module.exports = __webpack_public_path__ + "static/media/inproccess-icon.61ef2d6e.svg";